import { isEmptyObject } from './object';

export const hasBeenSubmitted = submitCount => submitCount > 0;

export const hasErrorsAndIsTouched = (errors, touched) => !isEmptyObject(errors) && !isEmptyObject(touched);
